// extracted by mini-css-extract-plugin
export default {"title":"tGgexPYnDR54lHyTbC0A"};